/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    City,
    CityFromJSON,
    CityFromJSONTyped,
    CityToJSON,
} from './City';

/**
 * 
 * @export
 * @interface Prefecture
 */
export interface Prefecture {
    /**
     * pref_idに相当
     * @type {string}
     * @memberof Prefecture
     */
    id: string;
    /**
     * 都道府県名
     * @type {string}
     * @memberof Prefecture
     */
    name: string;
    /**
     * 内包されている市区町村一覧
     * @type {Array<City>}
     * @memberof Prefecture
     */
    cities: Array<City>;
}

export function PrefectureFromJSON(json: any): Prefecture {
    return PrefectureFromJSONTyped(json, false);
}

export function PrefectureFromJSONTyped(json: any, ignoreDiscriminator: boolean): Prefecture {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'cities': ((json['cities'] as Array<any>).map(CityFromJSON)),
    };
}

export function PrefectureToJSON(value?: Prefecture | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'cities': ((value.cities as Array<any>).map(CityToJSON)),
    };
}

